export default {
  ebitda: true,
  existing_business_loan_payments: true,
}
